/**
 * TanStack Query hooks for `igaming-bonus-cost-deduction-from-ngr-share`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingBonusCostDeductionFromNgrShareQueryKeys,
	type CreateIgamingBonusCostDeductionFromNgrShareBody,
	type ListIgamingBonusCostDeductionFromNgrShareResponse,
	type IgamingBonusCostDeductionFromNgrShareRow,
} from "./api";

export function useIgamingBonusCostDeductionFromNgrShareList(): UseQueryResult<ListIgamingBonusCostDeductionFromNgrShareResponse, Error> {
	return useQuery({
		queryKey: igamingBonusCostDeductionFromNgrShareQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingBonusCostDeductionFromNgrShareCreate(): UseMutationResult<IgamingBonusCostDeductionFromNgrShareRow, Error, CreateIgamingBonusCostDeductionFromNgrShareBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingBonusCostDeductionFromNgrShareQueryKeys.all });
		},
	});
}

export function useIgamingBonusCostDeductionFromNgrShareDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingBonusCostDeductionFromNgrShareQueryKeys.all });
		},
	});
}
